import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PatientContactTypeEnum, PmsType } from '@ffd/api-client';
import { ContactData } from '../../../health-history-contact-row/health-history-contact-row.component';
import { SecondaryContactVM } from '../../../../health-history-dialog.service';

export interface ProfileContact {
  contactType: PatientContactTypeEnum;
  contactName?: string;
  phoneNumber?: string;
}

export const CONTACT_NAME_CHAR_LIMIT = 29;
export const CONTACT_PHONE_CHAR_LIMIT = 10;

// PMS-type visibility rules for the three secondary contacts.
// - DENTRIX_ASCEND, OPEN_DENTAL: hide Pharmacy.
// - EAGLESOFT: hide Pharmacy AND Emergency contact.
// - Other PMS types: show all three.
export function filterSecondaryContactsByPms(contacts: SecondaryContactVM[], pmsType: PmsType | null | undefined): SecondaryContactVM[] {
  return contacts.filter((c) => {
    if (c.contactType === PatientContactTypeEnum.PREFERRED_PHARMACY) {
      return pmsType !== PmsType.DENTRIX_ASCEND && pmsType !== PmsType.OPEN_DENTAL && pmsType !== PmsType.EAGLESOFT;
    }
    if (c.contactType === PatientContactTypeEnum.EMERGENCY_CONTACT) {
      return pmsType !== PmsType.EAGLESOFT;
    }
    return true;
  });
}

export function contactValidator(isPharmacy = false): ValidatorFn {
  // eslint-disable-next-line sonarjs/cognitive-complexity
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as ContactData | null;
    if (!value) return null;

    const errors: ValidationErrors = {};
    const nameValue = value.name?.trim() || '';
    const phoneValue = value.phone?.trim() || '';
    const isBothEmpty = !nameValue && !phoneValue;
    const isBothFilled = !!nameValue && !!phoneValue;
    const isValidPharmacy = isPharmacy && nameValue && !phoneValue;

    if (nameValue.length > CONTACT_NAME_CHAR_LIMIT) {
      errors['nameTooLong'] = true;
    }

    const trimmedPhoneValue = phoneValue.replaceAll(/\D/g, '');
    if (phoneValue && trimmedPhoneValue.length < CONTACT_PHONE_CHAR_LIMIT) {
      errors['phoneRequired'] = true;
    }

    if (!(isBothEmpty || isBothFilled || isValidPharmacy)) {
      if (nameValue && !phoneValue && !isPharmacy) {
        errors['phoneRequired'] = true;
      }
      if (!nameValue && phoneValue) {
        errors['nameRequired'] = true;
      }
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };
}
